/** Marketing site path; always shows the public landing page. */
export const PUBLIC_HOME_PATH = "/home";
